import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@pt/environment';

import {
  CoursesReportApiMock, CoursesReportApiService, MyWardsCoursesReportApiService,
} from './api';

export function getCoursesReportApi(router: Router) {
  if (environment.useMocks) {
    return inject(CoursesReportApiMock);
  }

  return router.url.includes('my-wards')
    ? inject(MyWardsCoursesReportApiService)
    : inject(CoursesReportApiService);
}
